import React from "react";

const OrderStatusChit = ({ status }) => {
  return (
    <div className="order-status-chit" style={{ background: getOrderStatusColor(status)}}>
      {getOrderStatusLabel(status)}
    </div>
  );
};

const getOrderStatusLabel = (status) => {
  switch (status) {
    case "draft":
      return "Draft";
    case "ready":
      return "Ready";
    case "locked":
      return "Locked";
    case "shipped":
      return "Shipped";
    default:
      return "Unknown";
  }
}

const getOrderStatusColor = (status) => {
  switch (status) {
    case "draft":
      return "#737373";
    case "ready":
      return "#0b7";
    case "locked":
      return "#FF0000";
    case "shipped":
      return "#3070E7";
    default:
      return "#eeeeee";
  }
}

export { getOrderStatusLabel, getOrderStatusColor, OrderStatusChit } 